import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  fetchPinnedFaqs,
  getCurrentUser,
} from '../utils/api'
import Navbar    from './Navbar'
import SearchBar from './SearchBar'
import FAQCard   from './FAQCard'

export default function PinnedFAQsPage({ branding, onLogout}) {
  const navigate = useNavigate()
  const [user, setUser]       = useState(null)
  const [loadingUser, setLoadingUser] = useState(true)
  const [rawFaqs, setRawFaqs] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')

  // 1) who’s logged in?
  useEffect(() => {
    (async () => {
      try {
        const u = await getCurrentUser()
        setUser(u)
      } catch {
        navigate('/')
      } finally {
        setLoadingUser(false)
      }
    })()
  }, [navigate])

  // 2) fetch pinned FAQs
  useEffect(() => {
    if (!user) return
    (async () => {
      try {
        const pins = await fetchPinnedFaqs()
        pins.sort((a, b) => a.position - b.position)
        setRawFaqs(pins)
      } catch (err) {
        console.error('Failed to load pinned FAQs', err)
      } finally {
        setLoading(false)
      }
    })()
  }, [user])

  const handleFaqDeleted = id =>
    setRawFaqs(f => f.filter(x => x.id !== id))

  const handleFaqUpdated = updated => {
    if (!updated.pinned) {
      setRawFaqs(f => f.filter(x => x.id !== updated.id))
    } else {
      setRawFaqs(f =>
        f
          .map(x => (x.id === updated.id ? updated : x))
          .sort((a, b) => a.position - b.position)
      )
    }
  }

  // filter by search term
  const faqs = rawFaqs.filter(f =>
    f.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
    f.answer.toLowerCase().includes(searchTerm.toLowerCase())
  )

  if (loadingUser) return <div className="container py-4">Loading…</div>
  if (loading)     return <div className="container py-4">Loading your pins…</div>

  return (
    <>
      <Navbar
        user={user}
        logoUrl={branding?.logo_url}
        onLogout={onLogout}     // ← just call back to App
      />

      <div className="pinned-faq-page container py-4">
        <button
          className="pinned-faq-page_back-btn btn btn-outline-secondary mb-3"
          onClick={() => navigate(-1)}
        >
          ← Back
        </button>

        <h2 className="pinned-faq-page_title mb-3">Your Pinned FAQs</h2>

        <SearchBar
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          placeholder="Search pinned FAQs…"
          className="pinned-faq-page_search mb-4"
        />

        {faqs.length === 0 ? (
          <p className="pinned-faq-page_empty-state text-muted">
            {searchTerm
              ? 'No pinned FAQs match your search.'
              : 'You haven’t pinned any FAQs yet.'}
          </p>
        ) : (
          <div className="pinned-faq-page_list row g-3">
            {faqs.map(faq => (
              <div key={faq.pin_id} className="pinned-faq-page_item col-md-6">
                <FAQCard
                  faq={faq}
                  currentUser={user}
                  onFaqDeleted={handleFaqDeleted}
                  onFaqUpdated={handleFaqUpdated}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  )
}
